export enum TemperatureTypeEnum{
    Ambient = 'Ambient',
    Chilled = 'Chilled',
    Frozen = 'Frozen',
}